// 第2弾: 倉庫出荷（stoq-worker）連携の状態（最終同期・直近エラー・追跡待ち・送信失敗）と「今すぐ同期」。
// 発送タブのヘッダ・精算・連携の OMS カード・ダッシュボードの要対応で共用する。
import { useCallback, useEffect, useState } from "react";
import { fetchGfShipStatus, postGfShipSync } from "../../api/giftingClient";
import type { GfShipStatus, GfShipSyncResponse, Loadable } from "../../types/gifting";
import { errMsg } from "./gfUtil";

export function useGfShipStatus(reloadKey: unknown) {
  const [status, setStatus] = useState<Loadable<GfShipStatus>>({ status: "loading" });
  const [syncing, setSyncing] = useState(false);

  const load = useCallback(async () => {
    try {
      setStatus({ status: "ok", data: await fetchGfShipStatus() });
    } catch (e) {
      setStatus({ status: "error", message: errMsg(e) });
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, reloadKey]);

  /** 同期を実行して結果を返す（失敗時は例外をそのまま投げる。呼び出し側でトースト） */
  const sync = useCallback(async (): Promise<GfShipSyncResponse> => {
    setSyncing(true);
    try {
      const r = await postGfShipSync();
      await load();
      return r;
    } finally {
      setSyncing(false);
    }
  }, [load]);

  return { status, syncing, sync, reload: load };
}
